export default __webpack_public_path__ + "static/hero-image-2-9847093c24ad2e9356430386197961dd.jpg";